import{getThemeConfig}from"./getThemeConfig";/**
 * Retrieves the global theme colors. Returns undefined when the given key doesn't exist in colors.
 *
 * @param {string|null} [key=null] settings key
 * @returns {Object|undefined|*}
 */export function getThemeColors(){var key=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var _getThemeConfig=getThemeConfig(),_getThemeConfig$color=_getThemeConfig.colors,colors=_getThemeConfig$color===void 0?{}:_getThemeConfig$color;return key?colors[key]:colors;}